export default class NativeEventEmitter {
  emit() {}
  addListener() {}
  removeSubscription() {}
}



// WEBPACK FOOTER //
// ../biz-micro-services-ui/packages/basement/utils/NativeEventEmitter.js